import * as React from "react";
import Component from "../../AbstractComponent";
import UnitServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/UnitServiceStatusTypeContainer";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
// import PersonLookup from "../Lookup/PersonLookup";
// import CompanyLookup from "../Lookup/CompanyLookup";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { PromptDialog } from "../Dialog/PromptDialog";
import Constants from "../../../Action/Constants";
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
import Select from "../../Partials/Material/Select";
import TextField from "../../Partials/Material/TextField";
import Card from '@material-ui/core/Card';

export default class UnitDetailsEditable extends Component {
  public defaultChargeTypeLabel: string = this.props.defaultChargeTypeLabel || "Other_payable"
  public defaultChargeTypeId: string = this.props.defaultChargeTypeId || TypeContainer.pickIdFromLabel("Other_payable");

	public state = {
    unit: null,
    attachments: [],
    removed: false,
    unitServiceStatus: UnitServiceStatusTypeContainer.pickIdFromLabel("MANAGEMENT"),
    unitServiceStatusDilaogOpen: false,
    unitType: 1,
    unitNumber: "",
    squareMeters: "",
    roomNumber: "",
    bedroomNumber: "",
    bathroomNumber: "",
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    if (this.props.unit) {
      const unit: UnitInterface = this.props.unit;

      this.setState({
        unit: unit,
        // CASA-7824
        attachments: this.props.attachments,
        removed: this.props.removed,
        unitServiceStatus: this.props.unitServiceStatus,
        unitServiceStatusDilaogOpen: this.props.unitServiceStatusDilaogOpen,
        unitType: this.props.unitType,
        unitNumber: this.props.unitNumber,
        squareMeters: this.props.squareMeters,
        roomNumber: this.props.roomNumber,
        bedroomNumber: this.props.bedroomNumber,
        bathroomNumber: this.props.bathroomNumber,
      });
    }
  }

  public componentWillReceiveProps(nextProps) {
    if(nextProps.unit){
      const unit: UnitInterface = nextProps.unit;

      this.setState({
        unit: unit,
        // CASA-7824
        removed: nextProps.removed,
        unitServiceStatus: nextProps.unitServiceStatus,
        unitServiceStatusDilaogOpen: nextProps.unitServiceStatusDilaogOpen,
        unitType: nextProps.unitType,
        unitNumber: nextProps.unitNumber,
        squareMeters: nextProps.squareMeters,
        roomNumber: nextProps.roomNumber,
        bedroomNumber: nextProps.bedroomNumber,
        bathroomNumber: nextProps.bathroomNumber,
        attachments: nextProps.attachments
      })
    }
  }

  public changeUnitServiceStatus  = () => {
    this.setState({
      unitServiceStatusDilaogOpen: true,
    });
  }

  public changeUnitType  = (event) => {
    if(typeof this.props.changeUnitType === "function") {
			return this.props.changeUnitType.call(this, event);
		}
  }

  public changeUnitNumber  = (event) => {
    if(typeof this.props.changeUnitNumber === "function") {
			return this.props.changeUnitNumber.call(this, event);
		}
  }

  public changeUnitSquareMeters  = (event) => {
    if(typeof this.props.changeUnitSquareMeters === "function") {
			return this.props.changeUnitSquareMeters.call(this, event);
		}
  }

  public changeUnitRoomNumber  = (event) => {
    if(typeof this.props.changeUnitRoomNumber === "function") {
			return this.props.changeUnitRoomNumber.call(this, event);
		}
  }

  public changeUnitBedroomNumber  = (event) => {
    if(typeof this.props.changeUnitBedroomNumber === "function") {
			return this.props.changeUnitBedroomNumber.call(this, event);
		}
  }

  public changeUnitBathroomNumber  = (event) => {
    if(typeof this.props.changeUnitBathroomNumber === "function") {
			return this.props.changeUnitBathroomNumber.call(this, event);
		}
  }

  public updateUnitServiceStatus  = (event) => {
    if(typeof this.props.updateUnitServiceStatus === "function") {
			return this.props.updateUnitServiceStatus.call(this, event);
		}
  }

	public getUnitStatusProperties = (unit: UnitInterface) => {
    let label = "";
    let color = "transparent";

		if (unit?.isRented) {
			label = this.trans("rented");
      color = "#43A047";
		}

    if (unit?.isEmpty) {
      label = this.trans("empty");
      color = "#F44336";
    }

    if (unit?.isEnding) {
      label = this.trans("ending");
      color = "#F5A623";
    }

    if (unit?.isExpiring) {
      label = this.trans("expiring");
      color = "#F5A623";
    }

    if (unit?.isInactive) {
      label = this.trans("label-deactivate");
      color = "#B2B2B2";
    }

    return {label: label, color: color};
  }

  public render() {
		const unit: UnitInterface = this.props.unit;

  	return (
			<React.Fragment>
				<div className="charge-summary">
					<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
						<div style={{display: "flex", alignItems: "baseline"}}>
							<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
								{this.trans("label-unit")}
							</div>
							<div className="title" style={{color: this.getUnitStatusProperties(unit)?.color}}>
								{this.getUnitStatusProperties(unit)?.label}
							</div>
						</div>
					</div>
					<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
						<div className="counterparty">
							{`${unit?.displayName}`}
						</div>
					</div>
					<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
						{this.trans(unit?.type?.label)}
					</div>
					<table>
						<tr>
							<td className="align-left first-column">
							{`${this.trans("title-address")}: `}
							</td>
							<td className="align-left">
								<div className="margin-wrapper">
									<div 
										className="link-to-entity" 
										onClick={() => this.redirect(`/app/property/update/${unit?.propertyId}/`)}
									>
										{`${unit?.displayName}`}
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td className="align-left first-column">
								{`${this.trans("owner")}: `}
							</td>
							<td className="align-left">
								<div className="margin-wrapper">
									<div 
										className="link-to-entity" 
										onClick={() => this.redirect(`/app/owner/update/${unit?.property?.companyId}/`)}
									>
										{`${unit?.property?.company?.displayName}`}
									</div>
								</div>
							</td>
						</tr>
					</table>
				</div>
				<div className="no-margins has-margin-bottom">
					<Card className="card">
						<div style={{maxWidth: "420px"}}>
							<form>
								{/* We decide to move service status in agency fee template
								<Select
									className="form-element full-size form-input scroll-to-unitTypeId correct-label-position"
									error={this.getErrorFor("unitServiceStatusId")}
									disabled={this.state.removed}
									value={this.state.unitServiceStatus}
									onChange={this.changeUnitServiceStatus}
									htmlFor="unitServiceStatusId"
									label={this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}
									name="unitServiceStatus" 
									id="unitServiceStatus"
								>
									{this.getUnitServiceStatusTypeSelectboxes()}
								</Select> */}
								<Select
									className="form-element full-size form-input scroll-to-unitTypeId correct-label-position"
									error={this.getErrorFor("unitTypeId")}
									disabled={this.state.removed}
									value={this.state.unitType}
									onChange={this.changeUnitType}
									htmlFor="unitTypeId"
									label={this.trans("unitupdate-tab/info-field/unittype-label")}
									name="unitType" 
									id="unitType"
								>
									{this.getUnitTypeSelectboxes()}
								</Select>

								{
									this.state.unit?.property?.units?.filter(unit => !unit?.removed)?.length > 1 && (
										<TextField
											autoComplete="off"
											// id="unitNumber"
											// name="unitNumber"
											className="form-element full-size scroll-to-unitNumber"
											type="text"
											label={this.trans("unitupdate-tab/info-field/unitnumber-label")}
											value={this.state.unitNumber}
											onChange={this.changeUnitNumber}
											disabled={this.state.removed}
											variant="standard"
											error={!!this.getErrorFor("unitNumber")}
										/>
									)
								}

								{
									this.state.unit?.property?.units?.filter(unit => !unit?.removed)?.length > 1 &&
									!!this.getErrorFor("unitNumber") && <div className="component-error-text">{this.getErrorFor("unitNumber")}</div>
								}

								{
									this.state.unit?.property?.units?.filter(unit => !unit?.removed)?.length > 1 && (
									<div className="hint-styles-wrapper">
										<span className="hint-styles">{this.trans("page/unitcreate-unitnumber-info")}</span>
									</div>
									)
								}

								<TextField
									autoComplete="off"
									className="form-element full-size scroll-to-squareMeters"
									label={this.trans("unitupdate-tab/info-field/squaremeters-label") + this.trans("field/optional")}
									value={this.state.squareMeters}
									onChange={this.changeUnitSquareMeters}
									disabled={this.state.removed}
									variant="standard"
									error={!!this.getErrorFor("squareMeters")}
								/>
								{!!this.getErrorFor("squareMeters") && <div className="component-error-text">{this.getErrorFor("squareMeters")}</div>}

								<TextField
									autoComplete="off"
									id="rooms"
									name="rooms"
									className="form-element full-size scroll-to-roomNumber"
									type="text"
									label={this.trans("unitupdate-tab/info-field/rooms-label") + this.trans("field/optional")}
									value={this.state.roomNumber}
									onChange={this.changeUnitRoomNumber}
									disabled={this.state.removed}
									variant="standard"
									error={!!this.getErrorFor("roomNumber")}
								/>
								{!!this.getErrorFor("roomNumber") && <div className="component-error-text">{this.getErrorFor("roomNumber")}</div>}

								<TextField
									autoComplete="off"
									id="bedroomNumber"
									name="bedroomNumber"
									className="form-element full-size scroll-to-bedroomNumber"
									type="text"
									label={this.trans("unitupdate-tab/info-field/separatebedrooms-label") + this.trans("field/optional")}
									value={this.state.bedroomNumber}
									onChange={this.changeUnitBedroomNumber}
									disabled={this.state.removed}
									variant="standard"
									error={!!this.getErrorFor("bedroomNumber")}
								/>
								{!!this.getErrorFor("bedroomNumber") && <div className="component-error-text">{this.getErrorFor("bedroomNumber")}</div>}

								<TextField
									autoComplete="off"
									// id="bathroomNumber"
									// name="bathroomNumber"
									className="form-element full-size scroll-to-bathroomNumber"
									type="text"
									label={this.trans("unitupdate-tab/info-field/bathrooms-label") + this.trans("field/optional")}
									value={this.state.bathroomNumber}
									onChange={this.changeUnitBathroomNumber}
									disabled={this.state.removed}
									variant="standard"
									error={!!this.getErrorFor("bathroomNumber")}
								/>
								{!!this.getErrorFor("bathroomNumber") && <div className="component-error-text">{this.getErrorFor("bathroomNumber")}</div>}

								{/* {this.state.beta && (
									<TextField
									autoComplete="off"
									id="publicationTitle"
									name="publicationTitle"
									className="form-element full-size scroll-to-publicationTitle"
									type="text"
									label={this.trans("unitupdate-tab/info-field/publicationtitle-label") + this.trans("field/optional")}
									value={this.state.publicationTitle}
									onChange={this.sync.bind(this, this.syncronizers.EVENT, "publicationTitle")}
									disabled={this.state.removed}
									variant="standard"
									error={!!this.getErrorFor("publicationTitle")}
									/>
									{!!this.getErrorFor("publicationTitle") && <div className="component-error-text">{this.getErrorFor("publicationTitle")}</div>}
								)} */}
							</form>
						</div>
					</Card>
					
					<PromptDialog 
						{...this.props}
						title={this.trans("page/unitupdate-section/info-changeunitservicestatus/dialogtitle")}
						content={
							UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus ?
							this.trans("page/unitupdate-section/info-changeunitservicestatus/dialoginfomanaged")
							:
							this.trans("page/unitupdate-section/info-changeunitservicestatus/dialoginactive")
						}
						openLeavePrompt={this.state.unitServiceStatusDilaogOpen}
						negativeButtonLabel={this.trans("button-cancel")}
						positiveButtonLabel={this.trans("button-confirm")}
						prioritizeClosing={true}
						onDiscard={() => { this.setState({ unitServiceStatusDilaogOpen: false }); }}
						onSave={() => { this.setState({ unitServiceStatusDilaogOpen: false }, () => {
							this.props.dispatch({
								type: Constants.GLOBAL_UNIT_CHANGE_SERVICE_STATUS_START,
								payload: {
									unitId: this.state.unit?.id,
									unitServiceStatusId:  UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") === this.state.unitServiceStatus ?
									UnitServiceStatusTypeContainer.pickIdFromLabel("MANAGEMENT")
									:
									UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE")
								},
								onSuccess: unit => {
									if (unit) {
										this.updateUnitServiceStatus(unit)
									}
								},
							});

						})}}
					/>
				</div>
			</React.Fragment>
    );
  }
}
